/**
 * Gatsby browser APIs.
 *
 * The WordPress site used `?lang=xx` query parameters (WPML) for its
 * translations. Old links of that form still arrive here; the Layout
 * component redirects them to the static `/xx/...` route of the same page.
 */
export const onClientEntry = () => {};
